import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CampaignFormValues } from 'src/models/Campaign.model';
import CampaignForm from '../Layouts/CampaignForm';
import { useAddCampaignMutation } from 'src/services/CampaignServices';
import { showToast } from 'src/utils/showToaster';


type Props = {
    onClose: () => void;
};

const AddCampaignFormWrapper = ({ onClose }: Props) => {

    const [addCampaign] = useAddCampaignMutation()

    // Form Initial Values
    const initialValues: CampaignFormValues = {
        campaignName: '',
        campaignGroupId: '',
    };

    // Validation Schema
    const validationSchema = object().shape({
        campaignName: string().required('Please campaign name'),
        campaignGroupId: string().required('Please select channel'),
    });

    // Handle Submit
    const handleSubmit = (
        values: CampaignFormValues,
        { setSubmitting, resetForm }: FormikHelpers<CampaignFormValues>
    ) => {
        const formattedValues = {
            campaignName: values?.campaignName,
            campaignGroupId: values?.campaignGroupId
        }
        addCampaign(formattedValues).then((res: any) => {
            if (res?.error) {
                showToast('error', res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast('success', res?.data?.message);
                    resetForm();
                    onClose();
                } else {
                    showToast('error', res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <CampaignForm formType='Add' formikProps={formikProps} onClose={onClose} />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddCampaignFormWrapper;